
import { useState, useEffect } from 'react';
import Button from '../base/Button';

export default function MobileBottomBar() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrolled = window.scrollY > 100;
      setIsVisible(scrolled);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleBuyNow = () => {
    window.open('https://entrega.logzz.com.br/pay/mem6qvd4r/1-kit-com-6-facas-promocao', '_blank');
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 p-3 z-50 lg:hidden shadow-lg">
      <div className="flex items-center justify-between gap-3">
        <div className="flex flex-col min-w-0 flex-shrink-0">
          <span className="text-xs text-gray-400">De R$ 219,99 por</span>
          <span className="text-xl font-bold text-red-600">R$ 129,90</span>
          <span className="text-xs text-gray-500">Pague na entrega</span>
        </div>
        
        <Button 
          onClick={handleBuyNow}
          size="md" 
          className="flex-1 text-base py-3 px-4"
        >
          <i className="ri-shopping-cart-line mr-1"></i>
          PEDIR AGORA
        </Button>
      </div>
    </div>
  );
}
